export default "__VITE_ASSET__DBiwEmVW__"